exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loadmorediv{\n    display:block;\n    margin:0 auto 30px auto;\n    max-width:140px;\n}\n.loadmorediv .btn.btn-outline-primary{\n    padding-right:20px;\n    padding-left:20px;\n}\n", ""]);

// exports
